// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "marked" + "." + "34b3ecd0cb86b64ec642" + ".js";
};